
import React, { FormEvent, useRef, useState } from "react";
import emailjs from '@emailjs/browser';
import '../styles/audit.scss';
import { LuSend } from "react-icons/lu";
import SweetAlert2 from 'react-sweetalert2';

function Audit() {
  const [emailSentNotification, setEmailSentNotification] = useState({});
  let form = useRef<HTMLFormElement | null>(null);
  let handleFormSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();


    if (form.current) {
      emailjs
      .sendForm('service_9ho8amn', '__ejs-test-mail-service__', form.current, 'aPqPLJsR3YQ6YKvrk',
      )
        
        .then(
          (response) => {
            setEmailSentNotification({
              show: true,
              icon: "success",
              title: "Message Sent!",
              text: "Thank you for your message. I will get back to you as soon as possible.",
              showConfirmButton: false,
              // timer: 5000,
              // timerProgressBar: true,
            });
          },
          (error) => {
            console.log(error.text);
          }
        );
    }

    e.currentTarget.reset();
  };

  return (
    <>
      <section id="audit" className="overflow-hidden">
        <div className="container">
          <div className="d-flex flex-column gap-2 mb-lg-5 mb-md-4 mb-4">
            <h1 className="h2 fw-bold text-center text-uppercase text-gradient audit-heading">
            Contact
            </h1>
          </div>
          <div className="row justify-content-center m-0 row-gap-4" data-aos="fade-right">
          
            <h2 className="h5 heading-color mt-10 audit-left-ctn__heading">
                I'd love to hear from you! Whether you have a project you'd like to discuss, a question, or just want to connect, feel free to reach out. You can contact me via email or phone, and I'll get back to you as soon as possible. Let's create something amazing together!
                </h2>
   
            <div className="col-lg-1 d-none d-lg-block"></div>
            <div className="col-md-5 audit-right-ctn" data-aos="fade-left">
              <div className="card p-4 rounded-4 audit-form">
                <form
                  ref={form}
                  onSubmit={handleFormSubmit}
                  className="d-flex flex-column gap-3"
                >
                  <div className="form-group">
                    <input
                      type="text"
                      name="from_name"
                      className="form-control p-2 px-3"
                      placeholder="Full Name"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      name="user_email"
                      className="form-control p-2 px-3"
                      placeholder="Email Address"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      name="user_url"
                      className="form-control p-2 px-3"
                      placeholder="Product Name or URL"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="phonenumber"
                      name="user_phonenumber"
                      className="form-control p-2 px-3"
                      placeholder="Phone Number"
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      className="form-control p-2 px-3"
                      rows={5}
                      placeholder="Share any details"
                    ></textarea>
                  </div>
                  <div className="m-0">
                    <button
                      type="submit"
                      className="btn btn-outline-primary btn-outline-theme rounded-3 d-inline-flex justify-content-center align-items-center gap-2"
                    >
                      <span>Submit</span>
                      <LuSend />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SweetAlert2 {...emailSentNotification} />
    </>
  );
}

export default Audit;